import { useStudioStore } from '@/store/studio-store'
import { hasAsIsSourceMarkup } from '@/features/preview/services/as-is-snapshot'

/**
 * The ONE place a React surface asks "is this As-Is snapshot the original
 * itself, or a structure read out of it?".
 *
 * `hasAsIsSourceMarkup` (as-is-snapshot.ts) is the predicate; this hook is the
 * predicate plus the store read, so no surface has to know that the answer
 * lives on `projectSettings` — and, more importantly, so no surface can
 * quietly answer the question a different way.
 *
 * History (task-4): the fix for this class of bug escaped three times, each
 * round onto a surface the previous round did not know existed — the pane
 * (round 1), the tab and the chat rail (round 2), five more via the shared
 * label hook plus a duplicate reimplementation inside ContextBadge (round 3).
 * Every escape had the same shape: a surface that decided source-truth-vs-
 * derived on its own instead of reading one answer. Round 4 collapses the
 * remaining independent store reads into this hook, so a single edit here
 * moves every surface at once — and a single mutation here fails every
 * surface's test at once, which is what makes the centralization checkable
 * rather than merely asserted.
 *
 * The As-Is pane itself (as-is-view.tsx) deliberately does NOT use this hook:
 * it is handed the snapshot as a prop and reads `snapshot.sourceMarkup`
 * directly, which is strictly stronger — it labels the object it was actually
 * given rather than re-deriving it from global state that could point
 * somewhere else.
 */
export function useAsIsSourceMarkupPresent(): boolean {
  const projectSettings = useStudioStore((state) => state.projectSettings)
  return hasAsIsSourceMarkup(projectSettings)
}
